export const sharedWebSocketRef: { current: WebSocket | null } = {
  current: null,
};
